/** @jsx jsx */
import React, { memo } from 'react';
import { css, jsx } from '@compiled/react';
import { N0, N20 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { DEFAULT_HEADER_ROW_ID, zIndex } from '../../../common/constants';
import { useListWidth } from '../../../common/context';
import { secondaryBorder } from '../../../common/styled';
import type { RenderHeaderItem } from '../../../renderers';

const rowHeaderCellStyles = css({
	position: 'sticky',
	flex: '0 0 auto',
	left: 0,
	padding: 0,
	backgroundColor: token('elevation.surface', N0),
	borderRadius: `${token('border.radius', '3px')} 0 0 0`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	zIndex: zIndex.ROW_HEADER,
});

const dateRowHeaderContainerStyles = css({
	position: 'absolute',
	boxSizing: 'border-box',
	width: '100%',
	height: '100%',
	backgroundColor: token('color.background.neutral', N20),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderTop: secondaryBorder,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderBottom: secondaryBorder,
	borderRadius: `${token('border.radius', '3px')} 0 0 0`,
});

const subRowHeaderContainerStyles = css({
	position: 'absolute',
	display: 'flex',
	flex: '0 0 auto',
	alignItems: 'center',
	boxSizing: 'border-box',
	width: '100%',
	height: '100%',
	padding: `0 ${token('space.200', '16px')} 0 ${token('space.100', '8px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderBottom: secondaryBorder,
});

export type Props = {
	id: string;
	itemHeight: number;
	renderListHeaderItem: RenderHeaderItem;
};

const ListHeaderCell = ({ id, itemHeight, renderListHeaderItem }: Props) => {
	const [listWidth] = useListWidth();

	return (
		<div
			role="rowheader"
			tabIndex={-1}
			css={rowHeaderCellStyles}
			style={{ width: `${listWidth}px`, height: `${itemHeight}px` }}
		>
			{id === DEFAULT_HEADER_ROW_ID ? (
				<div css={dateRowHeaderContainerStyles}>{renderListHeaderItem({ id })}</div>
			) : (
				<div css={subRowHeaderContainerStyles}>{renderListHeaderItem({ id })}</div>
			)}
		</div>
	);
};

export default memo<Props>(ListHeaderCell);
